import { AuthenticatedLayout } from "../../../../layouts";
import { EHTOntarioDueRemittanceTransacitons } from "../../../../components/DirectDeposit/Transactions/EHTOntarioDueRemittance";
import { FC } from "react";

export interface IEHTOntarioDueRemittanceTransacitonsPage { }

export const EHTOntarioDueRemittanceTransacitonsPage: FC<IEHTOntarioDueRemittanceTransacitonsPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="EHTOntario Due"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<EHTOntarioDueRemittanceTransacitons />}
		/>
	);
};
